<template>
  <HeroView
      title="Stack"
      text="Scale with confidence. Designed for merchants with large inventories, this theme replaces dozens of expensive apps with built-in professional features. Build your brand on a foundation of speed, performance, and reliability."
      purchase-link="https://themes.shopify.com/themes/stack/presets/stack"
      price="$380"
      img-main="/assets/imgs/themes/stack/hero/hero@2x.webp"
      img-set="/assets/imgs/themes/stack/hero/hero.webp 1x, /assets/imgs/themes/stack/hero/hero@2x.webp 2x"
      img-alt=""
  />

  <DemosView
      title="5 Sales-Optimized <br>Ready-to-Use Presets"
      text="Built to perform from launch — 5 presets with proven layouts and conversion-focused features."
      theme-id="stack"
  />
  <SubscribeSection theme="Stack" :id="3"/>
  <BannerView
      title="Create a Store Where Every Detail Drives a Sale"
      text="Each section is built to perform, with the filtering, promotion, and cart tools that guide customers from their first click to checkout, without a single point of friction."
      purchase-link="https://themes.shopify.com/themes/stack/presets/stack"
      price="$380"
      img-main="/assets/imgs/themes/stack/banner@2x.webp"
      img-set="/assets/imgs/themes/stack/banner.webp 1x, /assets/imgs/themes/stack/banner@2x.webp 2x"
      img-alt=""
      dark-bg
      section-bg="gray-section-bg"
  />
  <FeaturesStackView/>
  <SubscribeSection theme="Stack" :id="1"/>
  <BuiltView
      section-bg="gray-section-bg"
  />
  <DocView
      docUrl="https://ashstonestudios.zendesk.com/hc/en-us/articles/36631659100690-About-Stack"
  />
  <SubscribeNewsletterView theme="Stack" :id="2"/>
  <FinalView
      title="Launch with a Theme That Converts From Day One"
      text="Every feature in this theme is built to move customers toward checkout, reduce drop-offs, and keep them coming back for more."
      purchase-link="https://themes.shopify.com/themes/stack/presets/stack"
      price="$380"
      img-main="/assets/imgs/themes/stack/final@2x.webp"
      img-set="/assets/imgs/themes/stack/final.webp 1x, /assets/imgs/themes/stack/final@2x.webp 2x"
      img-alt=""
  />
</template>

<script>
import HeroView from '@/components/general/HeroView.vue'
import DemosView from '@/components/general/DemosView.vue'
import BannerView from '@/components/general/BannerView.vue'
import FeaturesStackView from '@/components/general/FeaturesStackView.vue'
import BuiltView from '@/components/general/BuiltView.vue'
import DocView from '@/components/general/DocView.vue'
import FinalView from '@/components/general/FinalView.vue'

export default {
  name: 'StackView',
  components: {
    HeroView,
    DemosView,
    BannerView,
    FeaturesStackView,
    BuiltView,
    DocView,
    FinalView
  }
}
</script>

<script setup>
import { useHead } from '@vueuse/head'
import SubscribeNewsletterView from "@/components/SubscribeNewsletterView.vue";
import SubscribeSection from "@/components/SubscribeSection.vue";

useHead({
  title: 'Stack — Shopify Theme for Product-First Stores',
  meta: [
    { name: 'description', content: 'Shopify theme for large catalogs. Bold layouts, advanced filters, and a shopping experience built for high-intent customers.' },

    { property: 'og:title', content: 'Stack — High-Volume Theme for Large Product Catalogs' },
    { property: 'og:description', content: 'Built for expansive inventories and multi-category stores, Stack combines powerful navigation, merchandising tools, and a seamless shopping experience.' },
    { property: 'og:image', content: '/assets/imgs/themes/stack/og_image.png' },
    { property: 'og:url', content: 'https://creativecommercelabs.com/themes/stack' },
    { property: 'og:type', content: 'website' },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:site_name', content: 'Stack' }
  ]
})
</script>
